import { css } from "@emotion/react";

import { colors } from "../../../styles";

export const propertyListingTileComponent = css`
  color: ${colors.gray};
  background-color: ${colors.softWhite};
  margin: 20px;
  position: relative;
  border: 2px solid transparent;
  width: 300px;
  transition: border 0.3s ease-in-out;

  &:hover,
  &:focus {
    border: 2px solid ${colors.secondary};
  }
`;

export const link = css`
  display: block;

  &:hover,
  &:focus {
    color: ${colors.gray};

    /* Change styles of property-listing-image-component */
  }
`;

export const details = css`
  padding: 10px;
`;

export const bedAndBath = css`
  margin: 20px 10px 0 0;
`;
